import { OrganizationUsersScreen } from "../organization-users";

// Organization → Managers. Members of the current organization holding the
// "manager" role — a filtered view of the shared team-management screen.
const Managers = () => <OrganizationUsersScreen roleFilter="manager" />;

export default Managers;
